<template>
  <div class="task-detail">
    <div class="title"><span>基本信息</span></div>
    <section class="base-info">
      <div class="form">
        <div class="file">
          <span class="file-name">文件：</span>
          <el-select v-model="file" filterable placeholder="请选择文件" value-key="id" @change="changeFile">
            <el-option v-for="file in files" :key="file.id" :label="file.name" :value="file" />
          </el-select>
        </div>
        <div class="row">
          <span class="task-name">任务资源库名称：</span>
          <el-input v-model="taskBase_name" placeholder="请输入任务资源库名称" />
        </div>
        <div class="row">
          <span class="task-name">任务资源库分类：</span>
          <el-select v-model="type" filterable placeholder="请选择任务资源库分类" value-key="code" @change="changeType">
            <el-option v-for="(type) in typeList" :key="type.code" :label="type.value" :value="type" />
          </el-select>
        </div>
      </div>
      <div class="task-info">
        <div class="row">
          <span>任务资源库描述：</span>
          <el-input v-model="taskBase_desc" type="textarea" placeholder="请输入任务资源库描述" />
        </div>
      </div>
    </section>
    <div class="title"><span>知识块的组合列表</span></div>
    <section v-loading="loading" class="knowledge">
      <div class="knowledge-block">
        <div class="header">
          <el-checkbox
            v-model="checkAll"
            class="check_all"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
          >全选</el-checkbox>
          <el-button @click="getGroups">组合</el-button>
        </div>
        <div class="blocks">
          <el-checkbox-group v-if="knowledgeBlocks.length" v-model="checkedBlocks" @change="changeBlocks">
            <div v-for="(check, index) in knowledgeBlocks" :key="index">
              <el-checkbox v-if="!Array.isArray(check.text)" border :label="check">
                <el-input
                  :id="check.text"
                  v-model="check.text"
                  type="textarea"
                  class="block_text"
                  placeholder="请填写知识块"
                  @input="textareaId = check.text"
                />
                <div v-if="file.identifyType === 'term'">
                  <el-input v-model="check.num" placeholder="请输入生成数量" @input="inputData(check)" />
                  <el-input v-model="check.params" type="textarea" placeholder="请输入生成要求" />
                </div>
                <div v-if="check.taskElements && check.taskElements.length" class="task-list">
                  <div>步骤集合如下：</div>
                  <div v-for="(task, task_i) in check.taskElements" :key="task_i" class="task-row">
                    <el-row class="task-detail_row">
                      <el-col :span="12">
                        <div class="qa-row">
                          <span class="title-short">问题：</span>
                          <span>{{ task.questions[0] }}</span>
                        </div>
                        <div class="qa-row">
                          <span class="title-short">答案：</span>
                          <span>{{ task.answer }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="qa-row">
                          <span class="title-long">问题意图：</span>
                          <span>{{ task.questionIntent }}</span>
                        </div>
                        <div class="qa-row">
                          <span class="title-long">答案意图：</span>
                          <span>{{ task.answerIntent }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <div>检查点：</div>
                      <div v-for="(c, c_i) in task.checkList" :key="c_i" class="check_point">
                        {{ c }}
                      </div>
                    </el-row>
                  </div>
                </div>
              </el-checkbox>
              <el-checkbox v-else :label="check" border>
                <section class="com_knows">
                  <div class="input_know">
                    <div v-for="c in check.text" :key="c.index">
                      <el-input
                        :id="c.text"
                        v-model="c.text"
                        class="block_text"
                        type="textarea"
                        placeholder="请填写知识块"
                        @input="textareaId = c.text"
                      />
                    </div>
                  </div>
                  <el-button
                    v-if="check.text.length > 1"
                    class="com_btn"
                    @click="compKnowBlocks(index, check)"
                  >拆解</el-button>
                </section>

                <div v-if="file.identifyType === 'term'">
                  <el-input v-model="check.num" placeholder="请输入生成数量" @input="inputData(check)" />
                  <el-input v-model="check.params" type="textarea" placeholder="请输入生成要求" />
                </div>
                <div v-if="check.taskElements && check.taskElements.length" class="task-list">
                  <div>步骤集合如下：</div>
                  <div v-for="(task, task_i) in check.taskElements" :key="task_i" class="task-row">
                    <el-row class="task-detail_row">
                      <el-col :span="12">
                        <div class="qa-row">
                          <span class="title-short">问题：</span>
                          <span>{{ task.questions[0] }}</span>
                        </div>
                        <div class="qa-row">
                          <span class="title-short">答案：</span>
                          <span>{{ task.answer }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="qa-row">
                          <span class="title-long">问题意图：</span>
                          <span>{{ task.questionIntent }}</span>
                        </div>
                        <div class="qa-row">
                          <span class="title-long">答案意图：</span>
                          <span>{{ task.answerIntent }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <div>检查点：</div>
                      <div v-for="(c, c_i) in task.checkList" :key="c_i" class="check_point">
                        {{ c }}
                      </div>
                    </el-row>
                  </div>
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
          <div v-else class="no-data">
            暂无知识块
          </div>
        </div>
      </div>
    </section>
    <div class="btn">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { fileList, taskBaseGenerate, base_taskList } from '@/api/knowledgeUpload'
import { getStoryType } from '@/api/exercise'
export default {
  data() {
    return {
      file_id: '',
      file: {},
      knowledgeBlocks: [], // 当前选中的文件带出的知识块
      checkedBlocks: [], // 选中的知识块
      files: [],
      type: {},
      typeList: [],
      taskBase_name: '',
      taskBase_desc: '',
      checkAll: false,
      isIndeterminate: false,
      copyKnowBlocks: '',
      textareaId: '',
      loading: false
    }
  },
  created() {
    console.log('params', this.$route.params)
    this.getFiles()
    this.getType()
  },
  updated() {
    !this.textareaId && this.$nextTick(() => {
      var textarea = document.getElementsByTagName('textarea')
      textarea.forEach(item => {
        item.style.height = item.scrollHeight > 52 ? item.scrollHeight + 'px' : 52 + 'px'
      })
    })
    this.textareaId && this.$nextTick(() => {
      var textarea = document.getElementById(this.textareaId)
      textarea.style.height = textarea.scrollHeight > 52 ? textarea.scrollHeight + 'px' : 52 + 'px'
    })
  },
  methods: {
    // 拆分组合后的知识块
    compKnowBlocks(index, knows) {
      this.$confirm('确认要拆分该组合知识块吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.knowledgeBlocks.splice(index, 1)
        if (this.knowledgeBlocks.length !== 0) {
          knows.text.forEach(k => {
            const oldFlag = false
            let newFlag = false
            for (let i = 0; i < this.knowledgeBlocks.length; i++) {
              const el = this.knowledgeBlocks[i]
              if (Array.isArray(el.text) && el.text.length > 1) {
                continue
              } else if (Array.isArray(el.text)) {
                newFlag = el.text[0].order > k.order
              } else {
                newFlag = el.order > k.order
              }
              if (newFlag && !oldFlag) {
                this.knowledgeBlocks.splice(i, 0, k)
                break
              }
            }
          })
        } else {
          knows.text.forEach(k => {
            this.knowledgeBlocks.splice(k.order, 0, k)
          })
        }

        this.checkedBlocks = []
      })
    },
    getType() {
      getStoryType().then(res => {
        console.log('getStoryType', res)
        this.typeList = res.data
      })
    },
    changeBlocks(val) {
      const count = val.length
      this.checkAll = count === this.knowledgeBlocks.length
      this.isIndeterminate = count > 0 && count < this.knowledgeBlocks.length
    },
    handleCheckAllChange(val) {
      this.checkedBlocks = val ? [...this.knowledgeBlocks] : []
      this.isIndeterminate = false
    },
    async getFiles() {
      await fileList().then(res => {
        console.log('file-list', res)
        this.files = res.data
        if (this.$route.params.id) {
          this.loading = true
          this.queryTaskList()
        }
      })
    },
    changeFile(file) {
      // 所选文件不是当前修改文件，则重置页面展示
      if (!this.file_id || this.file_id !== file.id) {
        this.knowledgeBlocks = []
        file.textBlocks.forEach((text, i) => {
          this.knowledgeBlocks.push({ text, num: 1, params: '', order: i })
        })
      } else {
        // 恢复所选的当前文件的知识块
        this.knowledgeBlocks = JSON.parse(this.copyKnowBlocks)
      }
    },
    changeType(type) {
      this.type = type
    },
    // 组合知识块
    getGroups() {
      if (this.checkedBlocks.length) {
        const arr = []
        this.checkedBlocks.forEach(block => {
          const i = this.knowledgeBlocks.findIndex(b => block === b)
          this.knowledgeBlocks.splice(i, 1)

          Array.isArray(block.text) && block.text.forEach(text => {
            arr.push(text)
          })
          !Array.isArray(block.text) && arr.push(block)
        })
        this.knowledgeBlocks.unshift({ num: 1, params: '', text: arr })
        this.checkedBlocks = []
        console.log('this.knowledgeBlocks', this.knowledgeBlocks)
      }
    },
    onSubmit() {
      if (!this.taskBase_name) {
        this.$message({
          message: `请填写步骤名称`,
          type: 'error',
          duration: 2 * 1000
        })
        return false
      }
      if (!this.checkedBlocks.length) {
        this.$message({
          message: `请至少选择一个选择知识块`,
          type: 'error',
          duration: 2 * 1000
        })
        return false
      }
      if (!this.type.value) {
        this.$message({
          message: `请至少选择一个任务资源库分类`,
          type: 'error',
          duration: 2 * 1000
        })
        return false
      }
      let isNext = true
      if (this.file.identifyType === 'term') {
        for (let index = 0; index < this.checkedBlocks.length; index++) {
          const el = this.checkedBlocks[index]
          if (!el.num || !el.params) {
            isNext = false
            this.$message({
              message: `请填写完整所选知识块对应的生成数量和生成要求`,
              type: 'error',
              duration: 5 * 1000
            })
            break
          }
        }
      }
      const params = {
        id: this.$route.params.id || '',
        storyFileId: this.file.id,
        name: this.taskBase_name,
        desc: this.taskBase_desc,
        type: this.file.identifyType,
        storyType: this.type.code,
        textTaskModels: [], // 选中的知识块
        uncheckedTexts: this.knowledgeBlocks.filter(item => !this.checkedBlocks.includes(item)) // 未选中的知识块
      }

      // 按照原知识块进行排序
      this.checkedBlocks.sort((a, b) => {
        return this.knowledgeBlocks.indexOf(a) - this.knowledgeBlocks.indexOf(b)
      })

      this.checkedBlocks.forEach((checkedBlock, i) => {
        const blocks = Array.isArray(checkedBlock.text) ? checkedBlock.text : [checkedBlock]
        const obj = {
          requirement: checkedBlock.params,
          num: checkedBlock.num,
          textBlocks: blocks,
          order: i
        }
        params.textTaskModels.push(obj)
      })
      console.log('params', params)
      isNext && taskBaseGenerate(params).then(() => {
        this.$router.push({ name: 'taskBaseList' })
        this.$message({
          message: `任务模板正在生成中～您可以刷新当前页面查看任务状态。模板创建成功后可点击故事列表页创建您的故事～`,
          type: 'success',
          duration: 4 * 1000
        })
      })
    },
    inputData(val) {
      if (val.num) {
        const reg = /^[1-9]\d*$/
        if (!reg.test(val.num)) {
          val.num = 1
        }
      }
    },
    async queryTaskList() {
      await base_taskList({ id: this.$route.params.id }).then(res => {
        console.log('task-list', res.data)
        this.loading = false
        this.file_id = res.data.storyFileId
        this.file = { id: res.data.storyFileId, identifyType: res.data.type }
        this.taskBase_name = res.data.name
        this.taskBase_desc = res.data.desc
        this.typeList.forEach(el => {
          if (el.code === res.data.storyType) {
            this.type = el
          }
        })
        res.data.textTaskModels.reverse().forEach(task => {
          if (task.textBlocks.length > 1) {
            const obj = {
              text: [],
              num: task.num,
              params: task.requirement,
              taskElements: task.taskElements
            }
            task.textBlocks.forEach(block => {
              obj.text.push(block)
            })
            this.knowledgeBlocks.unshift(obj)
            this.checkedBlocks.push(obj)
          } else {
            const obj = {
              text: task.textBlocks[0].text,
              order: task.textBlocks[0].order,
              num: task.num,
              params: task.requirement,
              taskElements: task.taskElements,
              checked: true
            }
            const i = res.data.uncheckedTexts.findIndex(item => item.order > obj.order)
            res.data.uncheckedTexts.splice(i, 0, obj)
          }
        })
        res.data.uncheckedTexts.forEach(uncheck => {
          const obj = {
            params: uncheck.params,
            num: 1,
            order: uncheck.order,
            text: uncheck.text,
            taskElements: uncheck.taskElements
          }
          this.knowledgeBlocks.push(obj)
          if (uncheck.checked) {
            this.checkedBlocks.push(obj)
          }
        })

        this.copyKnowBlocks = JSON.stringify(this.knowledgeBlocks)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-info{
  background: #fff;
  padding: 0 20px;
  margin-bottom: 15px;
  border-radius: 5px;
  font-size: 14px;
}
.title{
  font-size: 16px;
  font-weight: 600;
  position: relative;
  margin-bottom: 10px;
  &::before{
    position: absolute;
    content: "";
    width: 5px;
    height: 17px;
    background-color: #00f;
    margin-right: 10px;
  }
  span{
    margin-left: 10px;
  }
}
.form{
  display: flex;
  margin-top: 20px;
  /* justify-content: space; */
  .row{
    display: flex;
    align-items: center;
    margin-left: 30px;
  }
  ::v-deep{
    .el-select{
      .el-input{
        width: 250px;
      }
    }
    .el-input__inner{
      margin: 0;
    }

  }
}
.no-data {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
}

.el-checkbox {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  margin: 0 0 10px 0;
  margin-left: 0 !important;
}

.btn {
  text-align: end;
  margin-top: 10px;
}

.block_text {
  width: 100%;
  margin-bottom: 10px;
}

::v-deep {
  .el-checkbox__label {
    white-space: normal;
    flex: 1;
  }

  .el-input {
    width: 300px;
  }

  .el-input__inner {
    display: flex;
    align-items: center;
    margin: 0 0 10px;
  }

  .el-textarea__inner {
    resize: none;
    line-height: normal;
  }

  .el-col-12 {
    border-right: 1px solid;

    .qa-row {
      display: flex;

      .title-short {
        width: 50px;
        flex-shrink: 0;
      }

      .title-long {
        width: 70px;
        flex-shrink: 0;
      }
    }
  }

  .el-col-12:first-child {
    padding-right: 15px;
  }

  .el-col-12:last-child {
    border-right: 0;
    padding-left: 15px;
  }

  .check_all {
    margin-bottom: 0
  }
}

.task-detail {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f2f2f2;
  padding: 10px 20px;

  .task-info {
    margin-top: 20px;

    .row {
      margin-bottom: 15px;
      display: flex;
      align-items: center;

      span {
        width: 160px;
      }
    }

    .task-name {
      position: relative;
      padding-left: 10px;

      &::before {
        position: absolute;
        left: 0;
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }
  }

  .knowledge {
    flex: 1;
    display: flex;
    overflow: hidden;
    background: #fff;
    padding: 10px;
    border-radius: 5px;
    flex-direction: column;
  }

  .knowledge-block {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      ::v-deep{
        .el-checkbox{
          width: 60px;
          height: 36px;
          border: 1px solid #DCDFE6;
          margin-right: 20px;
          border-radius: 4px;
        }
        .el-checkbox__inner{
          display: none;
        }
        .el-checkbox__label{
          padding-left: 0;
          text-align: center;
        }
        .el-button{
          padding: 10px 15px;
        }
        .is-checked{
          border: 1px solid #409EFF;
        }
        .el-checkbox__input{
          display: none;
        }
      }
    }

    .blocks {
      overflow: auto;
      flex: 1;

      .task-list {
        margin: 10px 0;

        .task-row {
          border: 1px solid;
          padding: 10px;
          margin: 10px 0;
          border-radius: 5px;
        }

        .task-detail_row {
          padding-bottom: 5px;
          border-bottom: 1px solid;
          margin-bottom: 5px;
        }

        .check_point {
          margin-left: 15px;
        }
      }

      .com_knows {
        display: flex;

        .input_know {
          flex: 1;
        }

        .com_btn {
          height: 30px;
          margin-left: 5px;
          background: #419eef;
          color: #fff;
          border: 0;
          padding: 0 15px;
        }
      }
      ::v-deep{
        .is-bordered{
          padding: 0;
          border-radius: 0;
          border: 0;
        }
        .el-checkbox__label{
          padding: 15px 5px 10px 15px;
          border-radius: 4px;
          border: 1px solid #DCDFE6;
          margin-left: 10px;
        }
        .el-checkbox__inner{
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
